import { render, staticRenderFns } from "./SofPage.vue?vue&type=template&id=767ccfc1&scoped=true&"
import script from "./SofPage.vue?vue&type=script&lang=js&"
export * from "./SofPage.vue?vue&type=script&lang=js&"
import style0 from "./SofPage.vue?vue&type=style&index=0&id=767ccfc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ccfc1",
  null
  
)

export default component.exports